import { render, staticRenderFns } from "./ProductFaq.vue?vue&type=template&id=3d881403&scoped=true"
import script from "./ProductFaq.vue?vue&type=script&lang=js"
export * from "./ProductFaq.vue?vue&type=script&lang=js"
import style0 from "./ProductFaq.vue?vue&type=style&index=0&id=3d881403&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d881403",
  null
  
)

export default component.exports